import React, { useState } from 'react';
import { Modal, Button } from 'antd';

/**
 * ConfirmModal Widget
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const ConfirmModal = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  /**
   * showModal
   */
  const showModal = () => {
    setIsModalVisible(true);
  };

  /**
   * handleOk
   */
  const handleOk = () => {
    setIsModalVisible(false);
    props.onClick();
  };

  /**
   * handleCancel
   */
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        style={{ ...props.style }}
        type={props.btnType}
        onClick={showModal}>
        {props.txt}
      </Button>
      <Modal
        title="Do you want to upload again?"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}>
        <p>This will reset the Upload.</p>
      </Modal>
    </>
  );
};
